import React, { forwardRef } from "react";
import PropTypes from "prop-types";

import { Input } from "./index";

export const InputTelephone = forwardRef((props, ref) => {
  const { children, ...otherProps } = props;
  return (
    <Input ref={ref} type="tel" {...otherProps}>
      {children}
    </Input>
  );
});

InputTelephone.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  mask: PropTypes.shape({
    mask: PropTypes.string.isRequired,
    char: PropTypes.string.isRequired,
  }),
};

InputTelephone.defaultProps = {
  mask: {
    mask: "9999 9999999",
    char: "_",
  },
};

InputTelephone.displayName = "InputTelephone";

export default InputTelephone;
